import React from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import { getFormValues } from 'redux-form'
import {
  Fade,
  Collapse,
} from '@material-ui/core'
import {  
  Icon
} from 'semantic-ui-react'
import r from 'reactotron-react-js'

import { StdCard } from 'components'
import { numberFormat } from '../../helper'

import { 
  GRContainer,
} from 'routes/ProcurementSystem/GoodsServiceReceipt/styled'
import {
  CoverCont,
  HeaderTitle,
  GRTitle,
  GRCont,
  GRItemCont,
  GRItemHeader,
  GRItemRow
} from './styled'

const POHistory = props => {

  const { valueForm } = props

  const [indexCollapse,setIndexCollapse] = React.useState({})
  const [indexInnerCollapse,setIndexInnerCollapse] = React.useState({})

  

  const changeCollapse = (index) =>{
    let clone = JSON.parse(JSON.stringify(indexCollapse))
    clone[index] = clone[index]!=undefined?!clone[index]:false
    setIndexCollapse(clone)
  }
  
  const changeInnerCollapse = (index) =>{
    let clone = JSON.parse(JSON.stringify(indexInnerCollapse))
    clone[index] = clone[index]!=undefined?!clone[index]:false
    setIndexInnerCollapse(clone)
  }

  return (
    <Fade in={true} timeout={500}>
    <GRContainer>
      <StdCard title='Purchase Order History'>
        {valueForm.purchaseOrderByHistory.map(( item, i )=>{
          return (
            <CoverCont>
              <HeaderTitle onClick={()=>changeCollapse('a'+i)} className={`${(indexCollapse['a'+i]||false)?'select':''}`}>
                {item.poNo}
                <Icon name={`${indexCollapse['a'+i]!=undefined?indexCollapse['a'+i]?'angle up':'angle down':'angle up'}`} link/>
              </HeaderTitle>
              <Collapse in={indexCollapse['a'+i]!=undefined?indexCollapse['a'+i]:true}>
                <Fade in={true} timeout={500}>
                  <div>
                  {
                    item.goodsServiceReceiptHistoryGRs.map((gr,ii)=>{
                      return(
                      <GRCont>
                        <div className='line1'></div>
                        <div className='line2'></div>
                        <div style={{display:'flex',flexDirection:'column',width:'100%'}}>
                          <GRTitle onClick={()=>changeInnerCollapse('b'+i+ii)}>
                            <div className='txt'>{gr.grNo}</div>
                            <Icon name={`${indexInnerCollapse['b'+i+ii]!=undefined?indexInnerCollapse['b'+i+ii]?'angle up':'angle down':'angle up'}`} link />
                          </GRTitle>
                          <Collapse in={indexInnerCollapse['b'+i+ii]!=undefined?indexInnerCollapse['b'+i+ii]:true}>
                            <Fade in={true} timeout={500}>
                              <GRItemCont>
                                <GRItemHeader>
                                  <div style={{width:'25%'}}>Document Date</div>
                                  <div style={{width:'15%'}}>Item No.</div>
                                  <div style={{width:'20%'}}>Quantity</div>
                                  <div style={{width:'25%'}}>Amount</div>
                                  <div style={{width:'15%'}}>Currency</div>
                                </GRItemHeader>
                              {
                                gr.goodsServiceReceiptHistoryItems.map((grI)=>(
                                  <GRItemRow>
                                    <div style={{width:'25%'}}><Moment format="DD MMM YYYY">{grI.documentDate}</Moment></div>
                                    <div style={{width:'15%'}}>{grI.itemNo||'-'}</div>
                                    <div style={{width:'20%'}}>{numberFormat(grI.quantity,false,3)}</div>
                                    <div style={{width:'25%'}}>{numberFormat(grI.amount)}</div>
                                    <div style={{width:'15%'}}>{grI.currencyCode||'-'}</div>
                                  </GRItemRow>
                                ))
                              }
                              </GRItemCont>
                            </Fade>
                          </Collapse>
                        </div>
                      </GRCont>
                    )})
                  }
                  </div>
                </Fade>
              </Collapse>
            </CoverCont>
          )
        })}
      </StdCard>
    </GRContainer>
    </Fade>
  )   

}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formGR')(state)
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(POHistory)
